
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / infinite","xmlns":"http://www.w3.org/2000/svg","width":"23.5","height":"12.472"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M13.145 10.109a.75.75 0 011.21-.886 4.194 4.194 0 003.395 1.749 4.25 4.25 0 100-8.5 4.55 4.55 0 00-3.778 2.016l-.122.192-2.914 4.856a6.049 6.049 0 01-5.186 2.936 5.75 5.75 0 010-11.5 5.635 5.635 0 013.41 1.147L8.942.88a.75.75 0 01.509-.844l.1-.024a.75.75 0 01.844.509l.024.1.521 2.954a.75.75 0 01-.509.844l-.1.024-2.954.521a.75.75 0 01-.36-1.453l.1-.024 1.107-.2a4.138 4.138 0 00-2.474-.815 4.25 4.25 0 100 8.5 4.55 4.55 0 003.778-2.016l.122-.192 2.914-4.856A6.048 6.048 0 0117.75.972a5.75 5.75 0 110 11.5 5.693 5.693 0 01-4.605-2.363z","fill":"#011936"}})])
          )
        }
      }
    